import "./styles.css";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Topo } from "../Topo";
import { LoadingSpinner } from "../loading";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Menu } from "../Menu";
import { BreadcrumbComponent } from "../Breadcrumb";
import { Resultados } from "../Resultados";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderTree } from "@fortawesome/free-solid-svg-icons";
import { SelectOrdem } from "../SelectOrdem";

export default function LegislacaoComFiltro() {
  useEffect(() => {
    localStorage.setItem("visualizacao", "orgaos");
  }, []);

  const [page, setPage] = useState(0);
  const [pageOrgao, setPageOrgao] = useState(0);
  const [searchPageClicked, setSearchPageClicked] = useState(false); // Flag para indicar se o botão de pesquisa foi clicado
  const [resultOrgao, setResultOrgao] = useState({});
  const [loading, setLoading] = useState(false);
  const [numFound, setnumFound] = useState(null);
  const [cabecalho, setCabecalho] = useState("");
  const [searchOrdem, setSearchOrdem] = useState("&ordenar_por=ano%20desc,numero%20desc");
  const [selectedOrdemOption, setSelectedOrdemOption] = useState(null);
  const [text, setText] = useState("");
  const [origem, setOrigem] = useState(-1);
  const [tipo, setTipo] = useState(-1);
  const [nomeOrigem, setNomeOrigem] = useState("");
  const [nomeTipo, setNomeTipo] = useState("");
  const menuRef = useRef(null);
  const api = `${process.env.REACT_APP_API_BASE_URL}/buscar?`;
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const handleCloseMobileMenu = () => setShowMobileMenu(false);
  const handleShowMobileMenu = () => setShowMobileMenu(true);


  const options = [
    {
      value: "&ordenar_por=ano%20desc,numero%20desc",
      label: "Número decrescente",
    },
    {
      value: "&ordenar_por=ano%20asc,numero%20asc",
      label: "Número crescente"
    },    
    {
      value: "&ordenar_por=data_publicacao%20desc",
      label: "Publicação decrescente",
    },
    {
      value: "&ordenar_por=data_publicacao%20asc",
      label: "Publicação crescente",
    }    
  ];

  const handleSelectionOrdemChange = (selected) => {
    setSearchOrdem(selected.value);
    setSelectedOrdemOption(selected);
  };

  const handlePageSelectedOrgao = (pageNumber) => {
    setPageOrgao(pageNumber);
    setSearchPageClicked(true);
  };

  const handleMenuSelection = (nomeOrigem, nomeTipo) => {
    setNomeOrigem(nomeOrigem);
    setNomeTipo(nomeTipo);
  };

  const handleBreadcrumbClick = (origemId, tipoId) => {
    setTipo(tipoId);
    setOrigem(origemId);
    setPage(1);
    setCabecalho([cabecalho[0], "Todos"]);

    if (menuRef.current) {
      menuRef.current.setActiveMenuItens(origemId, tipoId);
    }
  };

  const filtrosDePesquisa = (
    <Menu
      ref={menuRef}
      pesquisado={handleSaveSearch}
      handleMenuSelection={handleMenuSelection}
      tipo={handleTipo}
      origem={handleOrigem}
      page={handlePageSelectedOrgao}
      disabled={loading}
    />
  );

  const fetchData = () => {
    const pageNumberOrgao = pageOrgao === 0 ? 1 : pageOrgao;

    const url = `${api}${searchOrdem}${
      tipo !== -1 ? `&tipo[]=${tipo}` : ""
    }&page=${pageNumberOrgao}${origem !== -1 ? `&origem[]=${origem}` : ""}`;

    axios
      .get(url)
      .then((response) => {
        const resultados = response.data.response;
        setResultOrgao(resultados);
        setnumFound(resultados?.numFound);

        const ids = resultados.docs.map((resultado) => resultado.id);

        const requisicoes = ids.map(
          (id, index) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                axios
                  .get(
                    `${process.env.REACT_APP_API_BASE_URL}/listar-relacionados?id=${id}`,
                    { timeout: 10000 }
                  )
                  .then((resposta) => {
                    resolve(resposta.data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              }, index * 10);
            })
        );

        Promise.all(requisicoes)
          .then((respostas) => {
            const resultadosAtualizados = resultados.docs.map(
              (resultado, index) => ({
                ...resultado,
                relacionados: respostas[index],
              })
            );

            const resultadosComNumFound = {
              ...resultados,
              docs: resultadosAtualizados,
            };
            setResultOrgao(resultadosComNumFound);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchData();
    if (searchPageClicked) {
      setSearchPageClicked(false);
    }
  }, [page, searchPageClicked, searchOrdem, text, origem, tipo]);

  function handleSaveSearch(pesquisa) {
    setText(pesquisa);
  }

  function handleTipo(e) {
    setTipo(e);
  }

  function handleOrigem(e) {
    setOrigem(e);
  }

  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (relacionadoId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [relacionadoId]: !prevState[relacionadoId],
    }));
  };

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo(0, 0);
    };

    if (loading) {
      handleScrollToTop();
    }

    handleScrollToTop();
  }, [loading]);

  return (
    <div>
      <div className="App">{/* <div className="Sidebar"> */}</div>
      <div className="bg-topo grey-border-bottom">
        <Topo
          handleCloseMobileMenu={handleCloseMobileMenu}
          handleShowMobileMenu={handleShowMobileMenu}
          showMobileMenu={showMobileMenu}
          SideBarMenu={filtrosDePesquisa}
          modo={"orgaos"}
        />
      </div>
      <Container fluid className="main-container">
        <Row>
          <Col
            xl={3}
            lg={3}
            md={3}
            className="sidebar grey-border-right d-none d-md-block"
          >
            <h2 className="secao">
              <FontAwesomeIcon icon={faFolderTree} /> Órgãos
            </h2>
            {filtrosDePesquisa}
          </Col>
          <Col xl={9} lg={9} md={9} sm={12} className="resultados">
            <Row>
              {numFound > 0 && (
                <div
                  className={`d-flex justify-content-between align-items-center mt-2 mb-2 fs-8`}
                >
                  <div>Resultados encontrados: {numFound}</div>
                  <div
                    className={`d-flex justify-content-end align-items-center`}
                  >
                    Ordenar por:&nbsp;
                    <SelectOrdem onChange={handleSelectionOrdemChange} options={options} selectedOption={selectedOrdemOption || options[0]} />
                  </div>
                </div>
              )}
            </Row>
            {loading ? (
              <span className="d-flex justify-content-center">
                <LoadingSpinner />
              </span>
            ) : (
              <>
                <BreadcrumbComponent
                  nomeOrigem={nomeOrigem}
                  nomeTipo={nomeTipo}
                  idOrigem={origem}
                  idTipo={tipo}
                  handleBreadcrumbClick={handleBreadcrumbClick}
                />

                <Resultados
                  result={resultOrgao}
                  getHighlightContent={null}
                  toggleExpanded={toggleExpanded}
                  expandedItems={expandedItems}
                  page={pageOrgao}
                  handlePageSelected={handlePageSelectedOrgao}
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
